module.exports = __webpack_public_path__ + "c4b5cbcbab3749eba1ef1e17f8a35882.png";